import moment from "moment";
import {
  DATE_FORMAT,
  DATE_SHORT_FORMAT,
  DATE_YEAR,
  DATE_YEAR_MONTH,
  DATE_YEAR_MONTH_DAY,
} from "constants/date";

const EXPORT_DATE_RANGE_SEPARATOR = "_";

export function formatDate(date: string, format: string) {
  return moment(date).format(format);
}

export const formatDateForChart = (date: string) => {
  const dateMoment = moment(date);
  const today = moment().startOf("day");
  const diff = dateMoment.diff(today, "days", true);
  if (diff === 0) {
    return "Today";
  }
  return dateMoment.format(DATE_SHORT_FORMAT);
};
export const getMonthsAndYearsBetweenDates = (from: string, to?: string) => {
  const dateStart = moment(from).startOf("month");
  const dateEnd = moment(to).endOf("month");
  const timeValues = [];
  let currentYear = "";

  while (dateStart.isBefore(dateEnd)) {
    const formattedDate = dateStart.format(DATE_YEAR_MONTH);
    const year = dateStart.format(DATE_YEAR);

    if (year !== currentYear) {
      timeValues.push(year);
      currentYear = year;
    }

    timeValues.push(formattedDate);
    dateStart.add(1, "month");
  }

  return timeValues;
};

export const isDateCorrectFormat = (
  date: string,
  formatToCheck: string
): boolean => {
  return moment(date, formatToCheck, true).isValid();
};

export const getExportDateRangeDays = (startDate: string, endDate: string) => {
  const [start, end] = [startDate, endDate].map(date =>
    moment.utc(moment(date).format(DATE_YEAR_MONTH_DAY))
  );

  return end.diff(start, "days") + 1;
};

export const getExportDateRangePeriod = (
  startDate: string,
  endDate: string
) => {
  return [
    moment(startDate).format(DATE_YEAR_MONTH_DAY),
    moment(endDate).format(DATE_YEAR_MONTH_DAY),
  ].join(EXPORT_DATE_RANGE_SEPARATOR);
};

export const getExportDateRangePeriodLabel = (
  period: string
): string | null => {
  const dates = period.split(EXPORT_DATE_RANGE_SEPARATOR);
  const areDatesValid =
    dates.length === 2 &&
    dates.every(date => isDateCorrectFormat(date, DATE_YEAR_MONTH_DAY));

  if (!areDatesValid) return null;

  return dates.map(date => moment(date).format(DATE_FORMAT)).join(" – ");
};
